/** Image Gallery actions.
* @module actions/content_types/get_pages
*/

import { GET_PAGES } from '../../constants/ActionTypes';

/**
* Get FAQ items.
* @function getPages
* @returns {Object} Images action.
*/
export function getPages(tag, lang='en') {
  const url = (tag === undefined) ? `/@search?portal_type=Document&fullobjects=1&b_size=200&Language=${lang}` : `/@search?portal_type=Document&Subject=${tag}&fullobjects=1&b_size=200&Language=${lang}`;
  return {
    type: GET_PAGES,
    request: {
      op: 'get',
      path: url,
    },
 };
}